import Vue from './vue.runtime.common.js';
import { DarkModePlugin } from './vue_plugins/DarkModePlugin';
import { AccessibilityModePlugin } from './vue_plugins/AccessibilityModePlugin';
import ComponentMonitor from 'common/scripts/mixin/report.js';
import ComponentError from '../report/report_component_error.js';
import WgUI from 'common/scripts/plugins/wgui.js';
import Prerender from 'common/jscore/prerender.js';
Vue.use(WgUI);

import Env from './env';
Vue.use(DarkModePlugin)

if(!Env.isCSR) {
    // 捕获vue中的未捕获错误
    Vue.config.errorHandler = function (err, vm, info) {
        console.error(err);
        WXGAME && WXGAME.Badjs && WXGAME.Badjs.push(err);
        ComponentError && ComponentError.report(err, vm, info);
    }

    Vue.use(ComponentMonitor)
    Vue.use(AccessibilityModePlugin);
    Prerender.install(Vue);

    // darkmode 模式，给 body 设置 .wg_dark_mode
    let DarkModeClass = 'wg_dark_mode'
    if (Env.isDarkMode) {
        document.body.classList.add(DarkModeClass)
    }
    Env.onDarkModeChange(() => {
        if( Env.isDarkMode ) {
            document.body.classList.add(DarkModeClass)
        }else {
            document.body.classList.remove(DarkModeClass)
        }
    })

    // 设计要求的中黑体，配合 less 中 .wg_font_medium 使用
    if (Env.isAndroid) {
        document.body.classList.add('wg_font_medium_andorid')
    }
}else{
    Vue.mixin({
        data() {
            return {
                isCSR: true
            }
        }
    });
}

export default Vue;
